<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "./components/Header";

export default {
  components: {
    Header
  }
};
</script>

<style lang="scss">
html,
body,
div,
p,
a,
span,
img,
h1,
h2,
h3,
h4,
header,
iframe {
  display: block;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 16px;
  font-weight: normal;
  outline: none;
  text-decoration: none;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  &:before {
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 16px;
    outline: none;
    text-decoration: none;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  &:after {
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 16px;
    outline: none;
    text-decoration: none;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
html {
  margin-top: 64px;
  padding-bottom: 1em;
}
</style>
